



































import {Component, Prop, Vue} from 'vue-property-decorator'
import Cookies from 'js-cookie'
import _ from 'lodash'
import {wt} from '@/api'
import changePwds from '@/components/changePwd.vue'
@Component({
    name: 'chooseAddress',
    components: { changePwds }
})
export default class chooseAddress extends Vue{
    public $refs!: {
        formData: HTMLFormElement;
        passwords: HTMLFormElement,
    }
    visible: boolean = false;
    showClose: boolean = true;
    showTips: boolean = false;


    public tableData: any = [];
    public allData: any = {};
    public formData: any = { value: '', appName: '', token: '' };

    async created(){}

    async open(item:any,data:any){
        this.visible = true
        this.showClose = item.showClose
        this.tableData = data
        this.allData = item
        this.formData.appName = item.Name
        this.formData.token = Cookies.get('token')
    }

    submit(){
        if(!this.formData.value){
            this.showTips = true
            return
        }
        else{
            this.showTips = false
            this.$refs.formData.validate((valid: boolean) => {
                if (valid) {
                    wt.Identity_SwitchLogin(this.formData).then((res:any) => {
                        if(res['Success']){
                            window.open(this.allData.Url+'?token='+Cookies.get('token'))  // 打开新窗口
                            this.handleClose()
                        }
                        else{
                            // this.$message({
                            //     message: res['Content'],
                            //     type: 'error'
                            // });
                        }
                    }).finally(() => {});
                } 
                else {
                    return false;
                }
            });

        }
        
    }

    handleClose(){
        this.visible = false
        this.showTips = false
        this.formData = { appName: '', value: '' }
        this.$emit('showDiag', false);
    }
}
